import React from 'react';

import {GenericModelViewer} from './GenericModelViewer';

export const GenericModelViewerListNode = React.memo(function GenericModelViewerListNode(props) {

    const {
        CustomData,
        Editable,
        FieldDef,
        Item,
        OnValidationUpdate = (values, guid) => {},
        RootData,
        UpdateItem = (x) => {},
    } = props;

    return <GenericModelViewer
        Model={FieldDef.model}
        Association={FieldDef.association}
        EditMode={Editable}
        RootData={RootData}
        Data={Item}
        SkipBorder={true}
        Update={UpdateItem}
        OnValidationUpdate={OnValidationUpdate}
        CustomData={CustomData}
    />;
});
